<div class="container">
  <h1 class="justify-content-center text-center">{{ isEdit ? 'Edit Event' : 'Create Event' }}</h1>

  <form [formGroup]="myForm">
    <div class="row">
      <mat-form-field class="col-md-4" appearance="outline">
        <mat-label>Name Of Event</mat-label>
        <input matInput placeholder="Name Of Event" formControlName="eventName">
      </mat-form-field>
      <mat-form-field class="col-md-4" appearance="outline">
        <mat-label>Event Type</mat-label>
        <mat-select placeholder="Type Of Event" formControlName="eventType">
          <mat-option *ngFor="let e of eventTypes$  | async" [value]="e">{{e}}</mat-option>
        </mat-select>
        <mat-error *ngIf="eventType?.touched && eventType?.invalid">Required</mat-error>
      </mat-form-field>
      <mat-form-field class="col-md-4" appearance="outline">
        <mat-label>Select Volunteer</mat-label>
        <mat-select formControlName="volunteer" multiple  (selectionChange)="selectVolunteer($event)" required>
          <mat-option *ngFor="let v of volunteersList"
                      [value]="{ id: v.id,volunteerNo:v.volunteerNo, name: v.fName + ' ' + v.lName }">
            {{ v.fName }} {{ v.lName }} ({{ v.volunteerNo }})
          </mat-option>
        </mat-select>
      </mat-form-field>

      <ng-container *ngIf="eventFor=='Centre'">
        <mat-form-field class="col-md-4" appearance="outline">
          <mat-label>Select Centre</mat-label>
          <mat-select formControlName="code" (selectionChange)="selectCode($event)" required multiple>
            <mat-option *ngFor="let t of (centre$|async)"
                        [value]="{id:t.centreCode,centreName:t.centreName}">{{ t.centreName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>

      <mat-form-field appearance="outline" class="col-md-4">
        <mat-label>Choose a date</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="eventDate">
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="col-md-4" appearance="outline">
        <mat-label>Event Time</mat-label>
        <input matTimepicker #t="matTimepicker" formControlName="eventTime" [value]="timeSelected"
               [strict]="false" id="timepicker-example" mode="12h"
               placeholder="Please select time..." name="time">
        <mat-icon matSuffix (click)="t.showDialog()">access_time</mat-icon>
        <mat-error *ngIf="eventTime?.touched && eventTime?.invalid">Invalid Date</mat-error>
      </mat-form-field>
      <mat-form-field class="col-md-4" appearance="outline">
        <mat-label>Short Description</mat-label>
        <input matInput placeholder="Short Description" formControlName="description">
      </mat-form-field>
      <hr>
      <h4>Contact Person For the Event</h4>
      <mat-form-field class="col-md-4" appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput placeholder="Name " formControlName="name">
      </mat-form-field>
      <mat-form-field class="col-md-4" appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput placeholder="Email" formControlName='email'>
      </mat-form-field>
      <mat-form-field class="col-md-4" appearance="outline">
        <mat-label>Contact Number</mat-label>
        <input matInput placeholder="Number" formControlName="number">
      </mat-form-field>
      <div class="d-flex justify-content-center gap-2">
        <button permission="Events" [permissionTypes]="[PermissionType.ALL, PermissionType.ADD]"
                mat-raised-button color="warn" type="reset"
                class="mx-4" (click)="cancel()">Cancel
        </button>

        <button *ngIf="isEdit" permission="Events"
                [permissionTypes]="[PermissionType.ALL, PermissionType.ARCHIVE]"
                mat-raised-button color="warn" type="button" (click)="deleteEvent()">
          Delete Event
        </button>

        <button permission="Events" [permissionTypes]="[PermissionType.ALL, PermissionType.ADD]"
                mat-raised-button color="primary"
                type="submit" (click)="createEvent()">
          {{ isEdit ? 'Update Event' : 'Create Event' }}
        </button>
      </div>
    </div>
  </form>
</div>
